import React from "react";

export default function DownloadApp() {
  return (
    <>
      <div className="d-flex flex-column flex-sm-column flex-1">
        <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center">
          <a href="https://apps.apple.com/ca/app/vennchat/id6443394582">
            <div className="btn">App Store</div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=ca.richlink.iment">
            <div className="btn">Google Play</div>
          </a>
          <div>
            <a href="https://vennchat.s3.ap-southeast-1.amazonaws.com/vennchat-app-playChina-prod-release-6.4.12.apk">
              <div className="btn">Chinese Mobile (Android)</div>
            </a>
            <a href="/notification-instructions">
              <p className="text-center text-white">
                Push notification <br /> settings instructions
              </p>
            </a>
          </div>
          <a href="/chinese-apple-instructions">
            <div className="btn">Chinese Mobile (Apple)</div>
          </a>
        </div>
        <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center" >
          <a href="https://vennchat.s3.ap-southeast-1.amazonaws.com/vennchat-desktop-mac-universal-7.43.22.dmg">
            <div className="btn">Mac</div>
          </a>
          <a href="https://vennchat.s3.ap-southeast-1.amazonaws.com/vennchat-desktop-win-x64-7.43.24.exe">
            <div className="btn">Windows</div>
          </a>
        </div>
      </div>

    </>
  );
}
